<template>
  <div class="view-content">
    <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="名称:" prop="searchName">
          <el-input v-model="search.searchName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="结算月份:" prop="month">
          <el-date-picker
            v-model="search.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="handleReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tools-box">
      <el-button
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="handleExport"
        >导出</el-button
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600"
      size="small"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
        fontWeight: 'bold',
        align: 'center',
      }"
    >
      <el-table-column
        prop="batchNo"
        label="批次编号"
        width="180"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="startDate"
        label="结算开始时间"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="endDate"
        label="结束时间"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="totalPayAmount"
        label="周期总实付"
        width="150"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="totalCommAmount" label="总佣金" align="center">
      </el-table-column>

      <el-table-column
        prop="actualPayAmount"
        label="实际打款金额"
        align="center"
      >
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>
      <el-table-column prop="status" label="结算状态" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 2"> 已打款 </el-tag>
          <el-tag type="primary" v-if="scope.row.status == 1"> 待打款 </el-tag>
          <el-tag type="danger" v-if="scope.row.status == 0"> 作废 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            class="el-icon-s-order table-btn btn-default"
            @click="handleDeatils(scope.row)"
          >
            打款信息
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="search.pageIndex"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="结算打款"
      :visible.sync="dialogVisible"
      width="720px"
      :close-on-click-modal="false"
      class="payment-dialog-final"
    >
      <!-- ---- 区域一：汇总信息 ---- -->
      <div class="block-summary">
        <div class="block-header">
          <span class="block-title"
            ><i class="el-icon-s-data"></i> 汇总信息</span
          >
        </div>
        <div class="summary-items">
          <div class="summary-item">
            <span class="summary-label">结算单数</span>
            <span
              class="summary-value"
              v-show="
                settleDetail && settleDetail.data && settleDetail.data.length
              "
              >{{ settleDetail.data.length }}</span
            >
          </div>
          <div class="summary-divider"></div>
          <div class="summary-item">
            <span class="summary-label">服务商家数</span>
            <span class="summary-value">1</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-item summary-highlight">
            <span class="summary-label">合计应结</span>
            <span class="summary-value amount"
              >¥ {{ settleDetail.totalOrderAmount }}</span
            >
          </div>
        </div>
      </div>

      <!-- ---- 区域二：结算明细 ---- -->
      <div class="block-detail">
        <div class="block-header">
          <span class="block-title"
            ><i class="el-icon-document"></i> 结算明细</span
          >
          <span
            class="block-badge"
            v-show="
              settleDetail && settleDetail.data && settleDetail.data.length
            "
            >{{ settleDetail.data.length }} 笔</span
          >
        </div>
        <div
          class="detail-list"
          v-show="settleDetail && settleDetail.data && settleDetail.data.length"
        >
          <div
            class="detail-row"
            v-for="(item, index) in settleDetail.data"
            :key="index"
          >
            <span class="row-index">{{ index + 1 }}</span>
            <span class="row-no">{{ item.settleNo }}</span>
            <span class="row-company">{{ item.companyName }}</span>
            <span class="row-amount">¥ {{ item.companyIncomeAmount }}</span>
          </div>
          <div v-if="!settleDetail.data.length" class="detail-empty">
            暂未选择结算单
          </div>
        </div>
      </div>

      <!-- ---- 区域三：打款信息 ---- -->
      <div class="block-form">
        <div class="block-header">
          <span class="block-title"><i class="el-icon-edit"></i> 打款信息</span>
        </div>

        <el-form
          :model="settleDetail"
          size="small"
          label-width="100px"
          class="payment-form-final"
        >
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="转账截图" prop="imageUrl">
                <div class="image-list-box">
                  <div
                    class="image-list-li"
                    v-for="(item, index) in settleDetail.imageUrl"
                    :key="index"
                  >
                    <el-image
                      :src="item"
                      class="image-thumb"
                      fit="cover"
                      :preview-src-list="settleDetail.imageUrl"
                      :z-index="3000"
                    />
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="remark">
            <span>{{ settleDetail.remark }}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetChSettlementList,
  DownLoadChSettle,
  GetPaySettleOK,
} from "@/api/order/index";
export default {
  name: "summarys",
  data() {
    return {
      search: {
        searchName: "",
        month: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      settleDetail: {
        data: [],
      },
      dialogVisible: false,
      idsIndex: 1,
    };
  },
  mounted() {
    let now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, "0");
    this.search.month = `${year}-${month}`;
    this.getTableData();
  },
  methods: {
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1; // 搜索时重置页码
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      GetChSettlementList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
    handleExport() {
      DownLoadChSettle(this.search).then((res) => {
        if (res.data.isSuccess) {
          if (res.data.data) {
            this.$message.success(res.data.message);
            window.open(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    },
    handleDeatils(row) {
      GetPaySettleOK({ paymentNo: row.paymentNo }).then((res) => {
        if (res.data.isSuccess) {
          this.settleDetail = res.data.data;
          this.dialogVisible = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.img-box {
  width: 130px;
  height: 130px;
}
/* ==========================================================
   弹窗样式 - 现代简洁版
   ========================================================== */

/* 弹窗容器 */
::v-deep .payment-dialog-final .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}
::v-deep .payment-dialog-final .el-dialog__header {
  padding: 18px 24px 14px 24px;
  border-bottom: 1px solid #f0f2f5;
}
::v-deep .payment-dialog-final .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}
::v-deep .payment-dialog-final .el-dialog__body {
  padding: 18px 24px 8px 24px;
}
::v-deep .payment-dialog-final .el-dialog__footer {
  padding: 12px 24px 18px 24px;
  border-top: 1px solid #f0f2f5;
}

/* ----- 区块通用 ----- */
.block-summary,
.block-detail,
.block-form {
  margin-bottom: 18px;
}

.block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.block-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}
.block-title i {
  margin-right: 6px;
  color: #409eff;
}

.block-badge {
  font-size: 12px;
  color: #86909c;
  background: #f2f3f5;
  padding: 0 10px;
  border-radius: 12px;
  line-height: 22px;
}

/* ----- 汇总信息 ----- */
.summary-items {
  display: flex;
  align-items: center;
  background: #f7f9fc;
  border-radius: 8px;
  padding: 14px 20px;
  border: 1px dashed #e8eaed;
}

.summary-item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex: 1;
}

.summary-divider {
  width: 1px;
  height: 30px;
  background: #d9dde4;
  margin: 0 16px;
}

.summary-label {
  font-size: 13px;
  color: #86909c;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.summary-highlight .summary-value {
  font-size: 20px;
  color: #f53f3f;
}

/* ----- 结算明细 ----- */
.detail-list {
  border: 1px dashed #e8eaed;
  border-radius: 8px;
  max-height: 160px;
  overflow-y: auto;
  background: #fafbfc;
}

.detail-row {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px dashed #f0f2f5;
  font-size: 13px;
}
.detail-row:last-child {
  border-bottom: none;
}

.row-index {
  width: 24px;
  height: 24px;
  background: #e8eaed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #4e5969;
  flex-shrink: 0;
  margin-right: 12px;
}

.row-no {
  font-weight: 500;
  color: #1d2129;
  min-width: 140px;
}

.row-company {
  color: #4e5969;
  flex: 1;
}

.row-amount {
  font-weight: 600;
  color: #f53f3f;
  white-space: nowrap;
}

.detail-empty {
  padding: 24px 0;
  text-align: center;
  color: #c9cdd4;
  font-size: 13px;
}

/* ----- 打款表单 ----- */
.payment-form-final .el-form-item {
  margin-bottom: 14px;
}

/* 上传 */
.upload-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}
.file-count {
  font-size: 12px;
  color: #86909c;
}
.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
.file-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f2f3f5;
  padding: 2px 10px 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #4e5969;
}
.file-tag .el-icon-close {
  cursor: pointer;
  font-size: 12px;
  color: #c9cdd4;
  margin-left: 2px;
}
.file-tag .el-icon-close:hover {
  color: #f53f3f;
}

.image-list-box {
  display: flex;
}
.image-list-li {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e8eaed;
  flex-shrink: 0;
  background: #fafbfc;
}

.image-thumb {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
}

.image-thumb .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
